<template>
  <div class="menuScreen">
    <MyButton class="themeChnager" @click.native="themeChange" :btn-icon="btnIcon"></MyButton>
    <slot name="title"></slot>
    <div class="content">
      <div class="left">
        <playButton @click.native="gameToggle"></playButton>
      </div>
      <div class="line" v-if="showScore"></div>
      <div class="right" v-if="showScore">
        <h2>Top Scores</h2>
        <div class="scores">
          <div class="score" @mouseover="hover($event)" @mouseout="outer($event)" v-for="(sc, key) in scores" :key="key">{{ sc.score }} <span class="name">{{ sc.name }}</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PlayButton from "@/components/menu_screen/PlayButton";
import MyButton from "@/components/MyButton";

export default {
  name: "MenuScreen",
  components: {
    playButton: PlayButton,
    MyButton: MyButton
  },
  props: ['gameToggle'],
  data() {
    return {
      scores:[],
      showScore:false,
      hovered:false,
      btnIcon:'wb_sunny'
    }
  },
  computed:{
  },
  methods:{
    hover(e){
      e.target.querySelector('.name').style.display = 'block'
    },
    outer(e){
      e.target.querySelector('.name').style.display = 'none'
    },
    themeChange(){
      if(document.querySelector('body').getAttribute('data-theme') === 'light'){
        document.querySelector('body').setAttribute('data-theme', 'dark')
        this.btnIcon = 'wb_sunny'
      } else {
        document.querySelector('body').setAttribute('data-theme', 'light')
        this.btnIcon = 'brightness_2'
      }
    },
    iconSetter(){
      if (document.querySelector('body').getAttribute('data-theme') === 'light'){
        this.btnIcon = 'brightness_2'
      } else {
        this.btnIcon = 'wb_sunny'
      }
    }
  },
  mounted() {
    this.iconSetter()
    let localScore = JSON.parse(localStorage.getItem('User Score'))
    if (localScore !== null){
      localScore.forEach(el => {
        // console.log(el)
        if (el.score > 0){
          this.scores.push(el)
          this.showScore = true
        }
      })
    }
  }
}
</script>

<style scoped>
h1 {
  color: var(--color);
  text-align: center;
  margin: 20px;
  letter-spacing: 10px;
}

.themeChnager{
  position: absolute;
  right: -60px;
  top: -60px;
}

h2 {
  color: var(--color);
  text-align: center;
  margin: 20px;
  letter-spacing: 5px;
}

.menuScreen {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
}

.content {
  display: flex;
  justify-content: center;
  height: 80%;
}

.left {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px;
  width: calc(50% - 61.5px);
  height: calc(100% - 60px);
}

.line {
  height: calc(100% - 60px);
  width: 1px;
  margin: 30px 1px;
  background-color: #a1a1a1;
}

.right {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin: 30px;
  width: calc(50% - 61.5px);
  height: calc(100% - 60px);
}

.scores {
  display: flex;
  flex-direction: column;
  height: 60%;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}

.score {
  color: var(--color);
  font-size: 28px;
  margin: 5px;
  transition: all .3s ease-in-out;
  cursor: pointer;
  position: relative;
}

.name{
  position: absolute;
  display: none;
  font-size: 15px;
  top: 20px;
  left: 70px;
  width: max-content;
}

.score:hover{
  font-size: 40px!important;
  /*text-shadow: 5px 5px 5px rgba(255, 255, 255, .5);*/
}
</style>